import Map from "../map/map.component";

const MonitoringMap = ({ sensors, field }) => {
  const polygon = field?.polygon;

  const transformedSensors = Array.isArray(sensors)
    ? sensors
        .filter(
          (sensor) =>
            Array.isArray(sensor?.gps_position) &&
            sensor.gps_position.length === 2
        )
        .map((sensor) => ({
          ...sensor,
          latitude: sensor.gps_position[0],
          longitude: sensor.gps_position[1],
        }))
    : [];

  return (
    <Map
      fieldPosition={polygon}
      polygonCoordinates={polygon}
      demoMapZoom={20}
      mode="demo"
      sensors={sensors}
      markers={transformedSensors}
    />
  );
};

export default MonitoringMap;
